import {
  FormCard,
  FormItem,
  FormRadio,
  FormRadioGroup,
  Input
} from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import type { FormInstance, RadioChangeEvent } from 'antd'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface MentalHealthActFormCardProps {
  form: FormInstance
}

export const MentalHealthActFormCard = ({
  form
}: MentalHealthActFormCardProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const mhaStatus =
    form.getFieldValue('mhaStatus') === undefined
      ? false
      : form.getFieldValue('mhaStatus')

  const [mhaTypeVisible, setMhaTypeVisible] = useState<boolean>(!!mhaStatus)

  const onMhaStatusChange = (event: RadioChangeEvent) => {
    setMhaTypeVisible(!!event.target.value)
  }

  return (
    <>
      <FormCard title={t(supConstants.MHA)}>
        <FormItem
          label={<Text>{t(supConstants.MHA_HAS_STATUS)}</Text>}
          name="mhaStatus"
          colon={false}
        >
          <FormRadioGroup onChange={onMhaStatusChange}>
            <FormRadio value text={t(supConstants.MHA_HAS_STATUS_YES)} />
            <FormRadio value={false} text={t(supConstants.MHA_HAS_STATUS_NO)} />
          </FormRadioGroup>
        </FormItem>
        {mhaTypeVisible && (
          <FormItem
            label={<Text>{t(supConstants.MHA_TYPE)}</Text>}
            name="mhaType"
          >
            <Input placeholder={t(supConstants.MHA_TYPE_PLACEHOLDER)} />
          </FormItem>
        )}
      </FormCard>
    </>
  )
}
